import React from 'react'
import { ImageContainer, BackgroundImage, ContentOverlay, Title, SubTitle } from '../styles/BackgroundImageStyle'
import {
    SectionContainer,
    GridContainer,
    NeighborCard,
    ImageCardContainer,
    NeighborImage,
    NeighborLink,
    Heading,
  } from '../styles/NeighborhoodStyles'

const Neighborhoods = () => {

    const neighborhood = [
        { id: 1, title: "Malibu", image: "/assets/images/search1.jpg" },
        { id: 2, title: "Bel Air", image: "/assets/images/search2.jpg" },
        { id: 3, title: "Pacific Palisades", image: "/assets/images/search3.jpg" },
        { id: 4, title: "Brentwood", image: "/assets/images/search4.jpg" },
        { id: 5, title: "Beverly Glen", image: "/assets/images/search5.jpg" },
        { id: 6, title: "Hollywood", image: "/assets/images/search6.jpg" },
        { id: 7, title: "Santa Monica", image: "/assets/images/search7.jpg" },
        { id: 8, title: "Venice", image: "/assets/images/search8.jpg" },
        { id: 9, title: "Westwood", image: "/assets/images/search9.jpg" },
        { id: 10, title: "Hollywood Hills", image: "/assets/images/search10.jpg" },
      ];

  return (
    <div>
        <ImageContainer>
                {/* Background Image */}
                <BackgroundImage
                src="/assets/images/inTheNews.jpg"
                alt="background-image"
                />
                {/* Content Overlay */}
                <ContentOverlay>
                <Title>Neighborhoods</Title>
                <SubTitle>Browse our comprehensive neighborhood guides to learn more about your desired area.</SubTitle>
                </ContentOverlay>
        </ImageContainer>
        

        <SectionContainer>
        <GridContainer>
            {neighborhood.map((neighbor) => (
            <NeighborCard key={neighbor.id}>
                <ImageCardContainer>
                <NeighborLink href="#home">
                    <NeighborImage src={neighbor.image} alt={neighbor.title} />
                    <Heading>{neighbor.title}</Heading>
                </NeighborLink>
                </ImageCardContainer>
            </NeighborCard>
            ))}
        </GridContainer>
        </SectionContainer>
    </div>
  )
}

export default Neighborhoods